/** English source of truth — every locale must cover these keys. */
export const en = {
  close: "Close",
  howToPlay: "How to play",
  dash: "Dash",
  duel: "Duel",
  ranks: "Ranks",
  garage: "Garage",
  shop: "Shop",
  settings: "Settings",
  tagline: "Neon courier. Don't crash.",
  bestMeters: "Best {n} m · {diff}",
  pause: "Pause",
  paused: "Paused",
  resume: "Resume",
  endRun: "End run",
  sound: "Sound",
  on: "On",
  off: "Off",
  muted: "Muted",
  muteSfx: "Mute music & SFX",
  pbGhost: "PB ghost",
  ads: "Ads",
  adsOff: "Off",
  adsConsentOff: "{mode} · consent off",
  language: "Language",
  langEn: "English",
  langFr: "Français",
  langIt: "Italiano",
  langEs: "Español",
  langDe: "Deutsch",
  pseudoRanks: "Pseudo (ranks)",
  pseudoHint:
    "Saved for the leaderboard. Edit anytime here — not after each race. No Apple account required.",
  gameCenter: "Game Center",
  open: "Open",
  gcOpening: "Opening Game Center…",
  gcIos: "Game Center is iOS-only.",
  gcSignIn: "Sign in to Game Center in Settings, then retry.",
  gcHint: "Apple ranks & achievements. Separate from in-app Ranks.",
  signInApple: "Sign in with Apple",
  linked: "Linked",
  link: "Link",
  appleLinked: "Apple linked — ranks sync to this ID.",
  appleLinkedWeb: "Apple linked (web test).",
  appleWaiting: "Waiting for Apple…",
  appleCancel: "Cancelled — nothing linked.",
  appleFail:
    "Apple didn’t finish (often a one-time index delay). Play with your pseudo — try again later.",
  appleHint:
    "Optional. Links ranks to this Apple ID across devices. Not required to play.",
  appleLinkedHint: "Ranks ID tied to Apple. Pseudo above stays editable.",
  restorePurchases: "Restore Purchases",
  restoring: "Restoring…",
  restored: "Purchases restored (if any).",
  restoreFail: "Restore failed: {reason}",
  restoreIos: "Restore is iOS-only.",
  appleId: "Apple ID",
  adPrivacy: "Ad Privacy Choices",
  manage: "Manage",
  privacy: "Privacy",
  support: "Support",
  settingsHint:
    "Swipe L/R to change lanes. Swipe up to jump — pick up cyan ↑ tokens (max {n}). Jump clears barriers, crates, holes and cars — not trucks. Garage → Worlds for Lunar / Magma.",
  playingAs: "Playing as {name}",
  noPseudo: "No pseudo yet — set one in Settings",
  loading: "Loading…",
  noScores: "No scores yet — be #1",
  difficultyLocked: "Difficulty locked to this duel.",
  diffNote: "Medium after 3 runs · Hard after 12. Speed ramps mid-run.",
  diffEasy: "Easy",
  diffMedium: "Medium",
  diffHard: "Hard",
  hintEasy: "Chill",
  hintMedium: "Arcade",
  hintHard: "Insane",
  runsLeft: "{n} runs left",
  runLeft: "1 run left",
  swipeHint: "Swipe L/R · swipe up to jump",
  swipeHintPower: " · tap ⚡ · hold = AUTO",
  speedUp: "SPEED UP",
  powerMagnet: "Magnet",
  powerPhase: "Phase",
  powerDefault: "Power",
  powerOn: "ON",
  powerAuto: "AUTO",
  powerHoldHint: "Tap to activate · hold to toggle AUTO",
  powerAria: "{label}{auto} — hold to toggle auto",
  powerAriaAuto: " (auto)",
  continueAd: "Continue (ad)",
  continueFree: "Continue (free)",
  continueRetry: "Retry continue",
  loadingAd: "Loading ad…",
  firstContinue: "First continue is free.",
  adsRemovedContinue: "Ads removed — continue free.",
  watchAd: "Watch an ad for one more chance.",
  leftCount: "({n} left)",
  outOfContinues: "Out of continues.",
  duelCrash: "First crash ends the duel.",
  adUnavailable: "Ad unavailable — try again or end the run.",
  adsBlocked: "Ads blocked — allow ads in Settings → Ad Privacy, then retry.",
  watchWholeAd: "Watch the whole ad to continue.",
  crash: "Crash!",
  newBest: "New best!",
  runOver: "Run over",
  theyCrashed: "They crashed first",
  youCrashed: "You crashed first",
  deadHeat: "Dead heat",
  duelOver: "Duel over",
  vsLasted: " — you lasted longer.",
  vsHeld: " — they held further.",
  vsSame: " — same distance.",
  vsLine: "vs {name} {m} m",
  resultCoins: "+{coins} coins · Best {best} m · {diff}",
  submitting: "Submitting…",
  pickPseudo: "Pick a pseudo for the ranks",
  offlineScore: "Offline — score saved locally",
  rankImproved: "Global #{rank} · {total} players",
  rankBestStill: "Best still {best} m · #{rank}",
  choosePseudo: "Choose your pseudo",
  savePseudo: "Save pseudo",
  asPlayer: "as {name}",
  editSettings: " · edit in Settings",
  rematch: "Rematch",
  playAgain: "Play again",
  passPhone: "Pass the phone",
  shareInvite: "Share / Invite",
  coinsPlus: "+{n} coins",
  menu: "Menu",
  launchBonus: "Launch bonus",
  welcomeTitle: "✦{n} on us",
  welcomeBody:
    "First open of this version — a little fuel for the Garage. Once only.",
  claimCoins: "Claim ✦{n}",
  infoLead: "Neon courier on three lanes. Dash as far as you can — don't crash.",
  controls: "Controls",
  swipeLR: "Swipe L / R",
  swipeLRDesc: " — change lanes",
  swipeUp: "Swipe up",
  swipeUpDesc: " — jump (needs a jump token)",
  continueInfo: "Continue",
  continueInfoDesc: " — first free, second via optional ad (off during a duel)",
  tapPower: "Tap ⚡",
  tapPowerDesc: " — active vehicle power (or press E)",
  twoPlayers: "2 players",
  hotseatInfo: "Pass the phone",
  hotseatInfoDesc:
    " — after a run, tap {pass}. Same road, your friend goes next.",
  ranksDuelInfo: "Ranks duel",
  ranksDuelInfoDesc:
    " — open {ranks}, tap {duel} on a score. You race that exact road.",
  shareInfo: "Share a link",
  shareInfoDesc:
    " — after a run, {share}. Friend opens the link and races your road.",
  twoPlayersRule:
    "Same obstacles, same seed. First crash loses — no continues in a duel.",
  boardHint:
    "Tap {duel} on a score to race that same road — first crash loses.",
  resultTwoP: "Play with a friend",
  obstacles: "Obstacles",
  rivalBikes: "Rival bikes",
  rivalDesc: "Jump over them — they brake behind crates & barriers.",
  trucks: "Trucks",
  truckDesc: "Too tall to jump. Change lanes.",
  barriers: "Barriers",
  barrierDesc: "Jump over them when you have a token.",
  crates: "Crates",
  crateDesc: "Jump clears them (some rides smash them).",
  collectibles: "Collectibles",
  coinsTitle: "Coins (✦)",
  coinsDesc: "Spend in the Garage to unlock rides.",
  jumpTokens: "Jump tokens",
  jumpDesc: "Stock up to {n} — swipe up to use.",
  infoFoot:
    "Speed ramps during the run. Pick difficulty before Dash. {garage} = rides & worlds. {ranks} = scores & duels. Daily missions pay ✦.",
  missions: "Missions {done}/{total}",
  missionsReady: " · tap to claim",
  claimed: "Claimed",
  playToStreak: "Play to streak",
  dayN: "Day {n}",
  streakClaim: "Claim ✦{n}",
  streakToast: "Streak +✦{n}",
  missionToast: "Mission +✦{n}",
  missionClaim: "Claim ✦{n}",
  missionDone: "Done",
  shopTitle: "Shop",
  noAds: "No Ads",
  noAdsBlurb: "Banners and interstitials off. Restore still works.",
  phantomPack: "Phantom GT pack",
  phantomPackBlurb: "Phantom GT · ✦{n} · No Ads",
  phantomPackGranted: " — already granted.",
  phantomPackShort: "Phantom GT pack · {price}",
  coinPouch: "Coin Pouch",
  coinChest: "Coin Chest",
  coinPackBlurb: "✦{n} for cars & worlds.",
  owned: "Owned",
  adsRemoved: "Ads removed.",
  adsRemovedWeb: "Ads removed (web test).",
  starterUnlocked: "Starter Pack unlocked.",
  starterUnlockedWeb: "Starter unlocked (web test).",
  coinsGranted: "+✦{n} · balance ✦{balance}",
  rides: "Rides",
  worlds: "Worlds",
  statSpeed: "Speed",
  statJump: "Jump",
  statCoins: "Coins",
  noSpecialPower: "No special power",
  passive: "Passive",
  active: "Active",
  equip: "Equip",
  equipped: "Equipped",
  tryRide: "Try",
  tryRideHint: "No coins or ranks — just a test drive.",
  practiceHud: "TEST",
  practiceOver: "Test drive",
  practiceNote: "Doesn't count — no coins, no ranks.",
  practiceCrash: "Test over — no coins, no ranks.",
  tryAgain: "Try again",
  backGarage: "Garage",
  getInShop: "Get in Shop",
  needMore: "Need ✦{n} more",
  buyPrice: "Buy · ✦ {n}",
  haveCoins: "✦ {price} · Have {have}",
  buyCoinsShop: "Buy coins in Shop",
  baseCoins: "Base coins",
  extraCoins: "+{pct}% coins",
  higherJump: " · higher jump",
  jumpHoles: " · jump the holes",
  prevVehicle: "Previous vehicle",
  nextVehicle: "Next vehicle",
  prevWorld: "Previous world",
  nextWorld: "Next world",
  duelBanner:
    "Duel vs {name} · {m} m · {diff} · {stage} — same road, first crash loses.",
  cancel: "Cancel",
  vsHud: "vs {name} {m}m",
  iapProductUnavailable:
    "Product unavailable: Apple hasn’t approved the IAP yet (Ready to Submit). The products already exist — no need to recreate them. They go on sale after App Review.",
  iapStoreUnavailable:
    "Store unavailable — try again on a real device with a sandbox Apple ID.",
  iapFailed: "Purchase failed: {reason}",
  shareDialog: "Share & invite friends",
  shareCopied: "Score + invite link copied!",
  shareNamed:
    "{who} dashed {meters}m{diff} in 3Dash — first crash loses.{challenge}",
  shareAnon:
    "I dashed {meters}m and grabbed {coins} coins in 3Dash{diff}. Beat my run!{challenge}",
  shareChallenge: " Same road: {url}",
  mission_play3: "Finish 3 runs",
  mission_reach400: "Reach 400 m in one run",
  mission_coins20: "Collect 20 coins today",
  mission_jumps8: "Jump 8 times today",
  mission_beatBest: "Beat your best",
  veh_dash_blurb: "Stock hoverbike. Balanced and free.",
  veh_bulldog_blurb: "Heavy chassis. Slow, but crates don't stand a chance.",
  veh_falcon_blurb: "Light frame built for air time.",
  veh_magneto_blurb: "Coin vacuum for long farming runs.",
  veh_wasp_blurb: "Stinger frame. Faster, snappier, no tricks.",
  veh_phantom_blurb: "Top speed. Ghost through anything — briefly.",
  pow_none: "No special power.",
  pow_none_wasp: "No special power — just pace.",
  pow_crush: "Crush crates on impact. Barriers & rivals still hurt.",
  pow_glider: "Glider — jump lasts +60% longer & higher.",
  pow_magnet: "Coin magnet for 6s. Cooldown 20s.",
  pow_phase: "Phase for 3s — pass through all obstacles. Cooldown 30s.",
  stage_neon: "Neon City",
  stage_lunar: "Lunar Dust",
  stage_volcano: "Magma Run",
  stage_ice: "Ice Flats",
  stage_neon_blurb: "Rain-slick lanes. The classic 3Dash run.",
  stage_lunar_blurb: "Low gravity — jumps float. +25% coins.",
  stage_volcano_blurb: "Lava cracks — jump the holes. +50% coins.",
  stage_ice_blurb: "White-out speed. Long jumps, thin ice holes. +20% coins.",
} as const;
